export default __webpack_public_path__ + "static/media/tour3.314783bc.PNG";